export default "__VITE_ASSET__D9gmqoRh__$_?component__"